<!-- @prettier -->
<template>
  <div class="p-l-15 p-r-15 p-t-15">
    <legend class="f-s-13 p-b-10 display-flex flex--justify-between">
      <slot name="title">Users</slot>
      <button
        @click="close()"
        type="button"
        data-testid="close-button"
        class="btn btn-xs btn-danger legend-right-button"
      >
        <i class="typcn typcn-delete"></i>
        {{ closeBtnText }}
      </button>
    </legend>
    <Invites
      :inviteTargetId="publisherId"
      :inviteTargetType="inviteTargetType"
      @created-new-invite="$emit('created-new-invite', publisherId)"
    ></Invites>
  </div>
</template>

<script>
import Invites from '@/modules/invites/components/invites';

export default {
  name: 'PublisherInvites',
  components: {
    Invites
  },
  props: {
    publisherId: {
      type: String,
      required: true
    },
    closeBtnText: {
      type: String,
      default: 'Close'
    }
  },
  computed: {
    inviteTargetType() {
      return 'affiliates';
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style></style>
